<script setup lang="ts">
import useCmd from "@/composables/useCmd";
import { formatTime } from "@/utils/date";
import { ButtonNormal, ModalDelete } from "lorga-ui";
import { toRefs } from "vue";

const props = defineProps<{
  query: () => void;
  blattId: string;
  zeitId: string;
  zeitStart: string;
  zeitEnde: string;
}>();
const { query } = toRefs(props);

const { commandModalOpen, commandRequest } = useCmd(query);
</script>

<template>
  <ButtonNormal kind="delete" @click="commandModalOpen = true">
    <ModalDelete
      v-model="commandModalOpen"
      submit="Löschen"
      title="Fahrzeit Löschen"
      :data="{
        action: 'tageskontrollblatt.fahrzeit_entfernen',
        tageskontrollblatt_id: blattId,
        fahrzeit_id: zeitId,
      }"
      :request="commandRequest"
    >
      Soll die Fahrzeit '{{ formatTime(zeitStart) }} -
      {{ formatTime(zeitEnde) }}' wirklich gelöscht werden?
    </ModalDelete>
    Löschen
  </ButtonNormal>
</template>
